import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Re-export image utilities from transformImage
export { getImageSrc, getImageSrcWithDefault, getAvatarSrc, getProxyImage, extractImageUrl } from "./transformImage";

/**
 * merge classnames
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * check if item exists in resourcePool
 */
export const check = (item: string, resourcePool: string[]) => {
	return resourcePool.some((p) => p === item);
};

/**
 * check if any item exists in resourcePool
 */
export const checkAny = (items: string[], resourcePool: string[]) =>
	items.some((item) => check(item, resourcePool));

/**
 * check if all items exist in resourcePool
 */
export const checkAll = (items: string[], resourcePool: string[]) =>
	items.every((item) => check(item, resourcePool));

/**
 * join url parts
 * @example
 * urlJoin('/admin/', '/api/', '/user/') // '/admin/api/user'
 * urlJoin('/admin', 'api', 'user/')     // '/admin/api/user'
 * urlJoin('/admin/', '', '/user/')      // '/admin/user'
 */
export const urlJoin = (...parts: string[]) => {
	const result = parts
		.map((part) => {
			return part.replace(/^\/+|\/+$/g, ""); // 去除两边/
		})
		.filter(Boolean);
	return `/${result.join("/")}`;
};

export const getStringLength = (str?: string) => {
	let len = 0;
	for (const char of Array.from(str || "")) {
		// 1. emoji 检测 (常见 Unicode 范围)
		if (
			/\p{Extended_Pictographic}/u.test(char) // emoji 字符
		) {
			len += 2;
		}
		// 2. 中文字符
		else if (/[\u4e00-\u9fff]/.test(char)) {
			len += 2;
		}
		// 3. 中文标点（常见全角符号区间）
		else if (/[\u3000-\u303F\uFF00-\uFFEF]/.test(char)) {
			len += 2;
		}
		// 4. 其他：英文/数字/英文标点
		else {
			len += 1;
		}
	}

	return len;
};

export const sliceByStringLength = (str: string | undefined, maxLength: number) => {
	let result = "";

	for (const char of Array.from(str || "")) {
		if (getStringLength(result + char) > maxLength) {
			break;
		}
		result += char;
	}

	return result;
};

export const IS_SAFARI = () => {
	const ua = navigator.userAgent.toLowerCase();
	const isiOSUA = /(iphone|ipad|ipod)/.test(ua);
	// @ts-ignore
	return typeof window.safari !== "undefined" || isiOSUA;
};

const UserProfilePath = "/user-manage/operation";
export const jump2UserProfile = (id: string) => {
	window.open(`${location.origin}${UserProfilePath}/${id}`, "_blank");
};
